'use client'

import '@/app/ui/globals.css'
import { useRouter } from 'next/navigation'

export default function Page() {
    const { replace } = useRouter()

    function handleClick(action?: string) {
        action ? replace(`/access/${action}`) : (window.location.href = '/')
    }

    return (
        <div className="grid w-full grid-cols-1 justify-items-center gap-4 md:w-2/3 lg:w-1/3">
            <div className="my-3 grid grid-cols-1 justify-items-center text-xl text-white">
                <p className="font-bold">BENVENUTO</p>
                <p>ENTRA NELL&apos;APP</p>
            </div>
            <button
                className="mobile-button-green"
                onClick={() => handleClick()}
            >
                ENTRA COME OSPITE
            </button>
            <div className="spacer-white w-5/6" />
            <button
                className="mobile-button-black"
                onClick={() => handleClick('login')}
            >
                ACCEDI
            </button>
            <button
                className="mobile-button-black"
                onClick={() => handleClick('register')}
            >
                REGISTRATI
            </button>
        </div>
    )
}
